export default "__VITE_ASSET__c5802a35__"